import { Stack, styled } from '@mui/material'

export const RestrictedContent = styled('div')`
  padding: 24px;
  a {
    color: ${(props) => props.theme.color.primary30};
    cursor: pointer;
  }
`

export const Header = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
  svg {
    flex-shrink: 0;
  }
  p {
    margin: 0;
    color: rgba(149, 164, 173, 1);
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
`
export const Content = styled('div')`
  border-radius: 6px;
  background: rgba(22, 25, 30, 1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: 16px;
  color: rgba(229, 234, 238, 1);
  font-size: 12px;
  line-height: 18px;
`
export const RestrictedList = styled('div')`
  border-radius: 6px;
  background: rgba(22, 25, 30, 1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: 12px 14px;
  margin-top: 14px;
  color: ${(props) => props.theme.color.text90};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`

export const Footer = styled('div')`
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: ${(props) => props.theme.color.text60};
  margin-top: 20px;
  a {
    color: ${(props) => props.theme.color.primary30};
    cursor: pointer;
  }
`
